import { observable, action, makeObservable } from 'mobx';
import { NumberListInputType } from './types';

export class NumberListInput implements NumberListInputType {
  dataType: string;

  label: string;

  placeholder?: string;

  tag: string;

  dropDownValues?: { [index: string]: number };

  @observable selectorValue!: string | null;

  @observable value!: number[];

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    dropDownValues,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: any) {
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.dropDownValues = dropDownValues;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(null); // set initial value
    this.onChangeValue([]); // set initial value
  }

  // onChange do not change the value, only the selecion
  @action
  onChange = (v: string | null) => {
    this.selectorValue = v;
  };

  // onChangeValue changes the array
  @action
  onChangeValue = (v: number[]) => {
    this.value = v;
    this.selectorValue = null;
  };

  @action
  clearValue = () => {
    this.selectorValue = null;
    this.value = [];
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
